// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:17:01

export default {
  "id": "2048-run-gorgeous-balls",
  "slug": "2048-run-gorgeous-balls",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1144b9340c2a4d359b2d03cb5ff1e3b7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1144b9340c2a4d359b2d03cb5ff1e3b7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "2048 Run Gorgeous Balls",
      "description": "2048 Run: Gorgeous Balls is a fun arcade game that invites you to chase high scores in a delightful environment! In this creative 2048-style game, you’ll control a colorful array of balls as they race along a dynamic track.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "ball",
        "track"
      ]
    },
    "zh-CN": {
      "title": "2048 美丽球跑",
      "description": "2048 Run: Gorgeous Balls 是一款有趣的街机游戏，邀请你在愉悦的环境中追逐高分！在这款创意十足的 2048 风格游戏中，你将操控五彩缤纷的球体沿着动态赛道竞速。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "谜题"
      ],
      "tags": [
        "街机",
        "球",
        "轨道"
      ]
    },
    "zh-TW": {
      "title": "2048 閃耀美麗球體",
      "description": "2048 Run: 美麗的球是款有趣的街機遊戲，邀請你在一個愉快的環境中挑戰高分！在這款創新的2048風格遊戲中，你將操控一組彩色的球，讓它們在動態的軌道上競速。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "電玩",
        "球",
        "軌道"
      ]
    },
    "zh-HK": {
      "title": "2048 閃耀美麗珠子",
      "description": "2048 Run: 美麗的球球是一款好玩的街機遊戲，邀請你在一個愉快的環境中挑戰高分！在這款創新的2048風格遊戲中，你將操控各種多彩的球球，在動態的軌道上競速。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "電玩場",
        "波珠",
        "軌道"
      ]
    },
    "ja": {
      "title": "2048 ゴージャスボールラン",
      "description": "2048 Run: Gorgeous Ballsは、楽しい環境でハイスコアを目指せる楽しいアーケードゲームです！この創造的な2048スタイルのゲームでは、色鮮やかなボールの群れを操作してダイナミックなトラックを走らせます。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "アーケード",
        "ボール",
        "トラック"
      ]
    },
    "ko": {
      "title": "2048 런 고어러스 볼스",
      "description": "2048 Run: Gorgeous Balls는 즐거운 아케이드 게임으로, 고득점을 쫓는 재미있는 환경을 제공합니다! 이 창의적인 2048 스타일 게임에서는 다양한 색상의 구슬을 조종하여 역동적인 트랙을 달리게 됩니다!",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "아케이드",
        "볼",
        "트랙"
      ]
    },
    "fr": {
      "title": "2048 Course de Balles Magnifiques",
      "description": "2048 Run: Gorgeous Balls est un jeu d'arcade amusant qui vous invite à chasser les records de scores dans un environnement delightful ! Dans ce jeu créatif à l'aspect 2048, vous contrôlerez une multitude de boules colorées qui s'élanceront sur une piste dynamique.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "arcade",
        "balle",
        "piste"
      ]
    }
  }
};
